import { createBrowserRouter } from 'react-router-dom';

import { AccountDeletionPage } from '@pukka/accountdeletion';
import { BillingPage, RecurringOutletTab, RecurringPaymentTab, RecurringPage, RedirectPage } from '@pukka/accountsettings';
import { CustomerDisplayCampaignPage, CustomerDisplaySettingsPage } from '@pukka/customerdisplay';
import DashboardPage from '@pukka/dashboard';
import { DiscountPage, PromoPage } from '@pukka/library';
import LoginPage from '@pukka/login';
import { QRISByGoPayPage } from '@pukka/payments';
import {
  CancelledTransactionPagelet,
  SuccessTransactionPagelet,
  TransactionPage,
  VoidTransactionPagelet,
  TransactionDetailPagelet,
  InvoiceReceiptPage,
} from '@pukka/reports';
import { MainLayout, ProtectedNavigation, RedirectNavigation } from '@pukka/ui-composite';

const router = createBrowserRouter([
  {
    element: <MainLayout />,
    path: '/v2',
    children: [
      {
        path: '',
        element: <RedirectNavigation path="/v2/dashboard" />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'library/discounts',
        element: (
          <ProtectedNavigation>
            <DiscountPage />
          </ProtectedNavigation>
        ),
      },
      // Hide promo from production
      import.meta.env.VITE_ENVIRONMENT !== 'production'
        ? {
            path: 'library/promo',
            element: <PromoPage />,
          }
        : {},
      {
        path: 'settings/customer-display',
        element: <RedirectNavigation path="/v2/customer-display/campaign" />,
      },
      {
        path: 'customer-display/campaign',
        element: (
          <ProtectedNavigation>
            <CustomerDisplayCampaignPage />
          </ProtectedNavigation>
        ),
      },
      {
        path: 'customer-display/settings',
        element: (
          <ProtectedNavigation>
            <CustomerDisplaySettingsPage />
          </ProtectedNavigation>
        ),
      },
      {
        element: <QRISByGoPayPage />,
        path: '/v2/payments/payment_methods',
      },
      {
        path: 'settings/billing/recurring',
        element: (
          <ProtectedNavigation>
            <RecurringPage />
          </ProtectedNavigation>
        ),
        children: [
          {
            path: 'payment',
            element: <RecurringPaymentTab />,
          },
          {
            path: 'outlet',
            element: <RecurringOutletTab />,
          },
        ],
      },
      {
        path: 'settings/billing/',
        element: (
          <ProtectedNavigation>
            <BillingPage />
          </ProtectedNavigation>
        ),
      },
      {
        path: 'settings/billing/redirect/:type?',
        element: (
          <ProtectedNavigation>
            <RedirectPage />
          </ProtectedNavigation>
        ),
      },
      {
        path: 'reports/transactions',
        element: (
          <ProtectedNavigation>
            <TransactionPage />
          </ProtectedNavigation>
        ),
        children: [
          {
            path: 'success',
            element: <SuccessTransactionPagelet />,
            children: [
              {
                path: ':id',
                element: <TransactionDetailPagelet />,
              },
            ],
          },
          {
            path: 'cancelled',
            element: <CancelledTransactionPagelet />,
            children: [
              {
                path: ':id/:token',
                element: <TransactionDetailPagelet />,
              },
            ],
          },
          {
            path: 'void',
            element: <VoidTransactionPagelet />,
          },
        ],
      },
    ],
  },
  {
    element: <InvoiceReceiptPage />,
    path: 'v2/reports/invoices/print/:token',
  },
  {
    element: <AccountDeletionPage />,
    path: '/v2/account-deletion',
  },
  import.meta.env.VITE_ENVIRONMENT !== 'production'
    ? {
        path: '/v2/login',
        element: <LoginPage />,
      }
    : {},
]);

export default router;
